import { render, staticRenderFns } from "./BannerTable.vue?vue&type=template&id=9153f9a4&scoped=true&"
import script from "./BannerTable.vue?vue&type=script&lang=js&"
export * from "./BannerTable.vue?vue&type=script&lang=js&"
import style0 from "./BannerTable.vue?vue&type=style&index=0&id=9153f9a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9153f9a4",
  null
  
)

export default component.exports